export default {
    main: {
        index: 'index',
        essay: 'essay',
        running: 'running',
        check: 'check',
        box: 'box',
        about: 'about',
        Travelling:'Travelling'
    },
    statistics: {
        info: 'A long-distance runner who can\'t run fast',
        essayCount: 'essay',
        checkCount: 'check',
        mileageCount: 'mileage',
        raceCount: 'race',
        medalsCount: 'medals'
    },
    maintenance: {
        info: 'This website is already up and running ',
        day: 'days',
        lang: 'language'
    },
    personal: {
        hometown: 'home',
        hometownAddress: 'ShanXi·LinFen',
        live: 'live',
        liveAddress: 'ZheJiang·NingBo',
        index: 'index',
        hobby: 'hobby',
        running: 'Feel free to run',
    },
    first: {
        one: 'It\'s a rather amazing site.',
        two: 'Maybe it\'s simpler.',
        three: 'But don\'t leave in a hurry.',
        four: 'Stay and take a look,There may be surprises.',
    },
    foot: {
        author: 'author : XiaoQi Copyright © 2023-2024 [https://xqcc.site]',
        ipc: 'ICP 2023028138-1',
        mpc:'M ICP 20247117',
        info: 'This website is provided by JD Cloud as a cloud service'
    },
    contact: {
        wechat: 'wechat',
        qq: 'QQ',
        foot: '.Contact me.',
        tens:'Ten years of covenant'
    }
}